import { memo } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

interface Props {
  courseId: number;
  currentTag: string;
  onUpdated: () => Promise<void>;
  versionNumber?: string;
}

const EditorVersionHistoryUpdateTag = ({
  courseId,
  currentTag,
  onUpdated,
  versionNumber
}: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async ({ tag }) => {
    if (versionNumber) {
      // update previous version
      await api.put(
        `/admin/courses/${courseId}/versions/${versionNumber}/tag`,
        { tag }
      );
    } else {
      // update "current" version, i.e. update course
      await api.put(`/admin/courses/${courseId}`, { currentVersionTag: tag });
    }

    await onUpdated();
    dispatch.addNotice({ text: messages.commonSetTagSuccess, type: 'success' });
  };

  const initialValues = { tag: currentTag || '' };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="tag"
      buttonIsDropdown
      buttonText={messages.commonSetTag}
      formAllowEmptyStrings={true}
      initialValues={initialValues}
      modalActionText={messages.commonSave}
      modalTitle={messages.commonSetTag}
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <FormGroup label={messages.commonTag}>
          <Text field="tag" placeholder={messages.commonAddText} />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default memo(EditorVersionHistoryUpdateTag);
